import axios from "../config/axiosInstance";

// Gửi request tạo URL thanh toán VNPay
export const createPaymentUrl = async (paymentData) => {
  const response = await axios.post(`payment/create-payment-url`, paymentData);
  return response.data;
};

// Gửi request tạo URL thanh toán PayOS
export const createPayOSUrl = async (paymentData) => {
  const response = await axios.post(`payment/create-payos-url`, paymentData);
  return response.data;
};

// Xử lý phản hồi từ VNPay
export const processVNPayReturn = async (queryParams) => {
  const response = await axios.get(`payment/vnpay-return`, {
    params: queryParams,
  });
  return response.data;
};

// Xử lý phản hồi từ PayOS
export const processPayOSReturn = async (queryParams) => {
  const response = await axios.get(`payment/payos-return`, {
    params: queryParams,
  });
  return response.data;
};
